/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useState, type ReactNode } from 'react';
import { C, TH, type ThemeName, type ThemeTokens, type BrandColors } from './tokens';

interface ThemeContextValue {
  theme: ThemeName;
  C: BrandColors;
  T: ThemeTokens;
  setTheme: (theme: ThemeName) => void;
  toggle: () => void;
}

const ThemeContext = createContext<ThemeContextValue | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<ThemeName>(() => {
    const stored = localStorage.getItem('mi_theme');
    return stored === 'dark' ? 'dark' : 'light';
  });

  const T = TH[theme] as ThemeTokens;

  const setThemeAndPersist = (next: ThemeName) => {
    setTheme(next);
    localStorage.setItem('mi_theme', next);
  };

  const toggle = () => setThemeAndPersist(theme === 'light' ? 'dark' : 'light');

  return (
    <ThemeContext.Provider value={{ theme, C, T, setTheme: setThemeAndPersist, toggle }}>
      <div style={{ background: T.bg, minHeight: '100vh', color: T.text }}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside <ThemeProvider>');
  return ctx;
}
